export const NAMESPACE = 'mylounge';
